import React from "react";

const NavigationTitle_class = "whitespace-nowrap truncate max-w-full text-lg";

interface Props {
    title: string;
}

export const NavigationTitle = (props: Props) => (
    <div className={NavigationTitle_class}>{props.title}</div>
);
